export default import.meta.ROLLDOWN_FILE_URL_ST8barsFccBS2ZwMSaSnzA